import { render, staticRenderFns } from "./CheckinPassenger.vue?vue&type=template&id=6568bfe6"
import script from "./CheckinPassenger.vue?vue&type=script&lang=js"
export * from "./CheckinPassenger.vue?vue&type=script&lang=js"
import style0 from "./CheckinPassenger.vue?vue&type=style&index=0&id=6568bfe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports